(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"));
	else if(typeof define === 'function' && define.amd)
		define(["_"], factory);
	else if(typeof exports === 'object')
		exports["tartan"] = factory(require("_"));
	else
		root["tartan"] = factory(root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	_.extend(module.exports, __webpack_require__(2));
	
	module.exports.defaults = __webpack_require__(3);
	module.exports.parse = __webpack_require__(11);
	module.exports.filter = __webpack_require__(25);
	module.exports.transform = __webpack_require__(28);
	module.exports.syntax = __webpack_require__(31);
	module.exports.render = __webpack_require__(33);
	module.exports.schema = __webpack_require__(35);
	module.exports.utils = __webpack_require__(4);


/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = {"version":"5.0.1"}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(4);
	
	module.exports.weave = {
	  // Thread above warp, threads under warp
	  plain: [1, 1],
	  serge: [2, 2]
	};
	
	module.exports.colors = utils.color.buildColorMap({
	  /* eslint-disable key-spacing */
	  B: '#304080', G: '#004c00', K: '#000000',
	  N: '#666666', R: '#c80000', T: '#603311',
	  W: '#ffffff', Y: '#ffe600'
	  /* eslint-enable key-spacing */
	});
	
	module.exports.warpAndWeftSeparator = '//';
	
	module.exports.insignificantTokens = [
	  'invalid',
	  'whitespace'
	];


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.error = __webpack_require__(5);
	module.exports.color = __webpack_require__(6);
	module.exports.token = __webpack_require__(7);
	module.exports.node = __webpack_require__(8);
	module.exports.sett = __webpack_require__(9);
	module.exports.repaint = __webpack_require__(10);


/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	var severity = {
	  error: 'error',
	  warning: 'warning',
	  notice: 'notice'
	};
	
	var message = {
	  invalidToken: 'Invalid token',
	  zeroWidthStripe: 'Zero-width stripe',
	  unexpectedToken: 'Unexpected token',
	  orphanedPivot: 'Orphaned pivot',
	  multipleWarpAnWeftSeparator: 'Only one warp/weft separator is allowed',
	  unmatchedBlockStart: 'Unmatched block start',
	  unmatchedBlockEnd: 'Unmatched block end',
	  extraTokenInInputSequence: 'Extra token in input sequence',
	  invalidMultiplier: 'Invalid multiplier value; replaced with default (1)'
	};
	
	module.exports.severity = severity;
	module.exports.message = message;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	function isValidColor(str, acceptShortFormat) {
	  if (acceptShortFormat) {
	    return /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(str);
	  }
	  return /^#[0-9a-f]{6}$/i.test(str);
	}
	
	function isSameColor(left, right) {
	  left = left.replace(/^\s*#/g, '').replace(/\s+$/g, '').toUpperCase();
	  right = right.replace(/^\s*#/g, '').replace(/\s+$/g, '').toUpperCase();
	  return left == right;
	}
	
	function normalizeColor(str) {
	  if (/^#?[0-9a-f]{6}$/i.test(str)) {
	    return '#' + str.replace(/^#/, '').toUpperCase();
	  }
	  if (/^#?[0-9a-f]{3}$/i.test(str)) {
	    // Duplicate each hexadecimal character
	    return '#' + str.replace(/^#/, '')
	      .replace(/[0-9a-f]/ig, '$&$&').toUpperCase();
	  }
	  return str;
	}
	
	function buildColorMap(colors) {
	  var result = {};
	  if (_.isArray(colors)) {
	    _.each(colors, function(token) {
	      result[token.name.toUpperCase()] = {
	        value: normalizeColor(token.color),
	        comment: _.isString(token.comment) ? token.comment : ''
	      };
	    });
	  } else
	  if (_.isObject(colors)) {
	    _.each(colors, function(value, name) {
	      result[name.toUpperCase()] = {
	        value: normalizeColor(value),
	        comment: ''
	      };
	    });
	  }
	  return result;
	}
	
	module.exports.isValidColor = isValidColor;
	module.exports.isSameColor = isSameColor;
	module.exports.normalizeColor = normalizeColor;
	module.exports.buildColorMap = buildColorMap;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	var tokenType = {
	  invalid: 'invalid',
	  whitespace: 'whitespace',
	  color: 'color',
	  stripe: 'stripe',
	  pivot: 'pivot',
	  literal: 'literal',
	  repeat: 'repeat'
	};
	
	function isToken(token, type) {
	  return _.isObject(token) && (token.type == type);
	}
	
	function isInvalid(token) {
	  return isToken(token, tokenType.invalid);
	}
	
	function isWhitespace(token) {
	  return isToken(token, tokenType.whitespace);
	}
	
	function isColor(token) {
	  return isToken(token, tokenType.color);
	}
	
	function isStripe(token) {
	  return isToken(token, tokenType.stripe);
	}
	
	function isPivot(token) {
	  return isToken(token, tokenType.pivot);
	}
	
	function isLiteral(token) {
	  return isToken(token, tokenType.literal);
	}
	
	function isRepeat(token) {
	  return isToken(token, tokenType.repeat);
	}
	
	function isSquareBracket(token) {
	  return isLiteral(token) && ((token.value == '[') || (token.value == ']'));
	}
	
	function isOpeningSquareBracket(token) {
	  return isLiteral(token) && (token.value == '[');
	}
	
	function isClosingSquareBracket(token) {
	  return isLiteral(token) && (token.value == ']');
	}
	
	function isParenthesis(token) {
	  return isLiteral(token) && ((token.value == '(') || (token.value == ')'));
	}
	
	function isOpeningParenthesis(token) {
	  return isLiteral(token) && (token.value == '(');
	}
	
	function isClosingParenthesis(token) {
	  return isLiteral(token) && (token.value == ')');
	}
	
	function pivotToStripe(token) {
	  if (isPivot(token)) {
	    token = _.clone(token);
	    token.type = tokenType.stripe;
	  }
	  return token;
	}
	
	function stripeToPivot(token) {
	  if (isStripe(token)) {
	    token = _.clone(token);
	    token.type = tokenType.pivot;
	  }
	  return token;
	}
	
	function newToken(type, value) {
	  var result = {
	    type: type,
	    source: '',
	    offset: -1,
	    length: -1
	  };
	  if (_.isString(value)) {
	    result.value = value;
	    result.length = value.length;
	  }
	  return result;
	}
	
	function newInvalid(value) {
	  return newToken(tokenType.invalid, value);
	}
	
	function newWhitespace(value) {
	  return newToken(tokenType.whitespace, value);
	}
	
	function newColor(name, value) {
	  var result = newToken(tokenType.color);
	  result.name = name;
	  result.color = value;
	  return result;
	}
	
	function newStripe(name, count) {
	  count = parseInt(count, 10) || 0;
	  if (count < 0) {
	    count = 0;
	  }
	
	  var result = newToken(tokenType.stripe);
	  result.name = name;
	  result.count = count;
	  return result;
	}
	
	function newPivot(name, count) {
	  count = parseInt(count, 10) || 0;
	  if (count < 0) {
	    count = 0;
	  }
	
	  var result = newToken(tokenType.pivot);
	  result.name = name;
	  result.count = count;
	  return result;
	}
	
	function newSquareBracket(value) {
	  return newToken(tokenType.literal, value);
	}
	
	function newOpeningSquareBracket() {
	  return newToken(tokenType.literal, '[');
	}
	
	function newClosingSquareBracket() {
	  return newToken(tokenType.literal, ']');
	}
	
	function newParenthesis(value) {
	  return newToken(tokenType.literal, value);
	}
	
	function newOpeningParenthesis() {
	  return newToken(tokenType.literal, '(');
	}
	
	function newClosingParenthesis() {
	  return newToken(tokenType.literal, ')');
	}
	
	function newLiteral(value) {
	  return newToken(tokenType.literal, value);
	}
	
	function newRepeat(count) {
	  var result = newToken(tokenType.repeat);
	  result.count = parseInt(count, 10) || 0;
	  if (result.count <= 0) {
	    result.count = 1;
	  }
	  return result;
	}
	
	module.exports = tokenType;
	
	module.exports.isToken = isToken;
	module.exports.isInvalid = isInvalid;
	module.exports.isWhitespace = isWhitespace;
	module.exports.isColor = isColor;
	module.exports.isStripe = isStripe;
	module.exports.isPivot = isPivot;
	module.exports.isSquareBracket = isSquareBracket;
	module.exports.isOpeningSquareBracket = isOpeningSquareBracket;
	module.exports.isClosingSquareBracket = isClosingSquareBracket;
	module.exports.isParenthesis = isParenthesis;
	module.exports.isOpeningParenthesis = isOpeningParenthesis;
	module.exports.isClosingParenthesis = isClosingParenthesis;
	module.exports.isLiteral = isLiteral;
	module.exports.isRepeat = isRepeat;
	
	module.exports.pivotToStripe = pivotToStripe;
	module.exports.stripeToPivot = stripeToPivot;
	
	module.exports.newToken = newToken;
	module.exports.newInvalid = newInvalid;
	module.exports.newWhitespace = newWhitespace;
	module.exports.newColor = newColor;
	module.exports.newStripe = newStripe;
	module.exports.newPivot = newPivot;
	module.exports.newSquareBracket = newSquareBracket;
	module.exports.newOpeningSquareBracket = newOpeningSquareBracket;
	module.exports.newClosingSquareBracket = newClosingSquareBracket;
	module.exports.newParenthesis = newParenthesis;
	module.exports.newOpeningParenthesis = newOpeningParenthesis;
	module.exports.newClosingParenthesis = newClosingParenthesis;
	module.exports.newLiteral = newLiteral;
	module.exports.newRepeat = newRepeat;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	function newStripe(token) {
	  return {
	    isStripe: true,
	    name: token.name,
	    count: token.count
	  };
	}
	
	function newBlock(items, reflect, repeat) {
	  repeat = parseInt(repeat, 10) || 0;
	  return {
	    isBlock: true,
	    items: _.filter(items, _.isObject),
	    reflect: !!reflect,
	    repeat: repeat >= 1 ? repeat : 1
	  };
	}
	
	function newRootBlock(items, reflect, repeat) {
	  var result = newBlock(items, reflect, repeat);
	  result.isRoot = true;
	  return result;
	}
	
	function parseRepeat(value) {
	  var result = parseInt(value, 10) || 0;
	  return result > 1 ? result : 1;
	}
	
	function calculateNodeHash(node) {
	  if (!_.isObject(node)) {
	    return '';
	  }
	  if (node.isStripe && (node.count > 0)) {
	    return node.name + node.count * parseRepeat(node.repeat);
	  }
	  if (node.isBlock) {
	    if (_.isArray(node.items) && (node.items.length > 0)) {
	      return '[' + (node.isRoot ? 'R' : 'B') +
	        '*' + parseRepeat(node.repeat) +
	        '/' + (node.reflect ? 'RF' : 'RP') + ':' +
	        _.chain(node.items)
	          .map(calculateNodeHash)
	          .join('')
	          .value() +
	        ']';
	    }
	  }
	  return '';
	}
	
	function calculateNodeWeight(node, returnRawWeight) {
	  var stripeCount = 0;
	  var blockCount = 0;
	
	  if (_.isObject(node)) {
	    if (node.isStripe) {
	      stripeCount++;
	    }
	
	    if (node.isBlock && _.isArray(node.items) && (node.items.length > 0)) {
	      if (!node.isRoot) {
	        blockCount++;
	      }
	      var multiplier = node.reflect ? 2 : 1;
	      _.each(node.items, function(item) {
	        if (_.isObject(item)) {
	          if (item.isBlock) {
	            var nested = calculateNodeWeight(item, true);
	            blockCount += nested.blocks * multiplier;
	          }
	          if (item.isStripe && node.isRoot && !node.reflect) {
	            // Calculate only stripes in root if it is not reflected
	            stripeCount++;
	          }
	        }
	      });
	    }
	  }
	
	  if (returnRawWeight) {
	    return {blocks: blockCount, stripes: stripeCount};
	  }
	
	  if ((blockCount == 0) && (stripeCount == 0)) {
	    return node.isRoot ? 0 : Number.MAX_VALUE;
	  }
	
	  return Math.sqrt(blockCount * blockCount + stripeCount * stripeCount);
	}
	
	function isSameNode(left, right) {
	  if (!_.isObject(left) || (!_.isObject(right))) {
	    return false;
	  }
	  if (left.isStripe && right.isStripe) {
	    return (left.name == right.name) && (
	      left.count * parseRepeat(left.repeat) ==
	      right.count * parseRepeat(right.repeat)
	    );
	  }
	  if (left.isBlock && right.isBlock) {
	    // Both should be root or not
	    if (left.isRoot != right.isRoot) {
	      return false;
	    }
	    // Both should be reflected or not
	    if (left.reflect != right.reflect) {
	      return false;
	    }
	    // Both should be repeated equal times
	    if (parseRepeat(left.repeat) != parseRepeat(right.repeat)) {
	      return false;
	    }
	    // Both should have same count of items
	    if (!_.isArray(left.items) || !_.isArray(right.items)) {
	      return false;
	    }
	    if (left.items.length != right.items.length) {
	      return false;
	    }
	
	    // Complex case: compare all items
	    var result = true;
	    _.each(left.items, function(leftItem, index) {
	      var rightItem = right.items[index];
	      if (!isSameNode(leftItem, rightItem)) {
	        result = false;
	        return false; // Break
	      }
	    });
	    return result;
	  }
	  return false;
	}
	
	module.exports.newStripe = newStripe;
	module.exports.newBlock = newBlock;
	module.exports.newRootBlock = newRootBlock;
	module.exports.isSameNode = isSameNode;
	module.exports.calculateNodeHash = calculateNodeHash;
	module.exports.calculateNodeWeight = calculateNodeWeight;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var color = __webpack_require__(6);
	
	function getColor(name, colors, defaultColors) {
	  var temp = colors[name];
	  if (_.isObject(temp) && color.isValidColor(temp.value)) {
	    return temp.value;
	  }
	  temp = defaultColors[name];
	  if (_.isObject(temp) && color.isValidColor(temp.value)) {
	    return temp.value;
	  }
	  return null;
	}
	
	function compile(items, colors, defaultColors) {
	  colors = _.extend({}, colors);
	  defaultColors = _.extend({}, defaultColors);
	  return _.chain(items)
	    .map(function(item) {
	      if (_.isObject(item) && item.isStripe) {
	        var count = parseInt(item.count, 10) || 0;
	        if (count > 0) {
	          var color = getColor(item.name, colors, defaultColors);
	          if (color) {
	            return [color, count];
	          }
	        }
	      }
	      return null;
	    })
	    .filter()
	    // Merge stripes with same colors
	    .reduce(function(accumulator, item) {
	      var prev = _.last(accumulator);
	      if (prev) {
	        if (color.isSameColor(prev[0], item[0])) {
	          prev[1] += item[1];
	          return accumulator;
	        }
	      }
	      accumulator.push(item);
	      return accumulator;
	    }, [])
	    .value();
	}
	
	function getPatternMetrics(pattern, weave) {
	  if (!_.isArray(weave) || (weave.length < 2)) {
	    weave = [1, 1];
	  } else {
	    weave = weave.slice(0, 2);
	  }
	  pattern = _.filter(pattern, function(item) {
	    return _.isArray(item) && (item.length >= 2) && (item[1] > 0);
	  });
	
	  var lengthOfPattern = 0;
	  var lengthOfCycle = 0;
	  if (pattern.length > 0) {
	    lengthOfPattern = _.reduce(pattern, function(result, item) {
	      return result + item[1];
	    }, 0);
	
	    var weaveLength = _.sum(weave);
	    lengthOfCycle = lengthOfPattern;
	    while (lengthOfCycle % weaveLength != 0) {
	      lengthOfCycle += lengthOfPattern;
	    }
	  }
	
	  return {
	    length: lengthOfPattern,
	    fullCycle: lengthOfCycle
	  };
	}
	
	function reflectAndRepeat(block) {
	  var items = block.items;
	  var repeat = block.repeat;
	  var reflect = block.reflect;
	
	  // Special case - single item cannot be reflected, but can be repeated
	  if (items.length <= 1) {
	    if ((items.length == 1) && (repeat > 1)) {
	      var item = _.clone(items[0]);
	      item.count *= repeat;
	      block = _.clone(block);
	      block.items = [item];
	    }
	    return block;
	  }
	
	  var result;
	  var temp;
	
	  if (reflect) {
	    temp = items.slice(1, -1);
	    temp.reverse();
	    result = items.concat(temp);
	  } else {
	    result = items;
	  }
	
	  temp = [];
	  for (var i = 1; i <= repeat; i++) {
	    [].push.apply(temp, result);
	  }
	  result = temp;
	
	  if (reflect && !block.isRoot) {
	    result.push(items[0]);
	  }
	
	  block = _.clone(block);
	  block.items = result;
	  block.reflect = false;
	  block.repeat = 1;
	
	  return block;
	}
	
	module.exports.compile = compile;
	module.exports.getPatternMetrics = getPatternMetrics;
	module.exports.reflectAndRepeat = reflectAndRepeat;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global window */
	
	var _ = __webpack_require__(1);
	
	var requestAnimationFrame = (function() {
	  var result = null;
	  if (typeof window != 'undefined') {
	    if (_.isObject(window)) {
	      result = window.requestAnimationFrame ||
	        window.webkitRequestAnimationFrame ||
	        window.mozRequestAnimationFrame ||
	        window.msRequestAnimationFrame;
	    }
	  }
	  return result || setTimeout;
	})();
	
	var cancelAnimationFrame = (function() {
	  var result = null;
	  if (typeof window != 'undefined') {
	    if (_.isObject(window)) {
	      result = window.cancelAnimationFrame ||
	        window.webkitCancelAnimationFrame ||
	        window.mozCancelAnimationFrame ||
	        window.msCancelAnimationFrame;
	    }
	  }
	  return result || clearTimeout;
	})();
	
	function factory(callback) {
	  if (!_.isFunction(callback)) {
	    return _.identity;
	  }
	
	  var callbackId = null;
	  var callbackContext = null;
	  function repaint() {
	    callbackId = null;
	    callbackContext = null;
	    callback(callbackContext);
	  }
	
	  var result = function(context) {
	    if (!callbackId) {
	      callbackId = requestAnimationFrame(repaint);
	      callbackContext = context;
	    }
	  };
	
	  result.flush = function() {
	    result.cancel();
	    repaint();
	    return this;
	  };
	
	  result.cancel = function() {
	    if (callbackId) {
	      cancelAnimationFrame(callbackId);
	    }
	    callbackId = null;
	    callbackContext = null;
	    return this;
	  };
	
	  return result;
	}
	
	module.exports = factory;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var autodetectSource = __webpack_require__(12);
	var tokenize = __webpack_require__(15);
	var utils = __webpack_require__(4);
	var defaults = __webpack_require__(3);
	
	var defaultOptions = {
	  errorHandler: null,
	  processTokens: null,
	  buildSyntaxTree: null,
	  foreseeLimit: 1,
	  getSourceMeta: function(source) {
	    return _.omit(source, [
	      'warp', 'weft', 'threadcount', 'sett', 'palette', 'colors'
	    ]);
	  },
	  // Used only if `source` is an object (or JSON) and has different
	  // warp and weft, and `buildSyntaxTree` is not specified
	  warpAndWeftSeparator: defaults.warpAndWeftSeparator
	};
	
	function chooseNonEmptyString(values) {
	  var result = _.filter(values, function(value) {
	    return _.isString(value) && (value.length > 0);
	  });
	  return result.length > 0 ? _.first(result) : '';
	}
	
	function chooseRootBlock(values) {
	  var result = _.filter(values, function(value) {
	    return _.isObject(value) && value.isBlock && value.isRoot &&
	      _.isArrayLike(value.items);
	  });
	  return result.length > 0 ? _.first(result) : utils.node.newRootBlock([]);
	}
	
	function parse(parsers, source, options) {
	  var context = tokenize(source, parsers, options);
	  var result = context.parse();
	  if (_.isFunction(options.processTokens)) {
	    result = options.processTokens(result);
	  }
	  if (_.isFunction(options.buildSyntaxTree)) {
	    result = options.buildSyntaxTree(result);
	  }
	  return result;
	}
	
	function factory(parsers, options) {
	  options = _.extend({}, defaultOptions, options);
	
	  return function(source) {
	    source = autodetectSource(source);
	
	    var result;
	
	    if (_.isString(source.warp) || _.isString(source.weft)) {
	      var warp = _.trim(chooseNonEmptyString([source.warp, source.weft]));
	      var weft = _.trim(chooseNonEmptyString([source.weft, source.warp]));
	      var warpIsSameAsWeft = warp == weft;
	      warp = parse(parsers, warp, options);
	      if (warpIsSameAsWeft) {
	        // Create AST with same warp and weft; use meta from warp;
	        // do not use palette
	        result = {
	          meta: _.extend({}, warp.meta),
	          warp: chooseRootBlock([warp.warp, warp.weft])
	        };
	        result.weft = result.warp;
	      } else {
	        weft = parse(parsers, weft, options);
	        if (_.isArrayLike(warp) && _.isArrayLike(weft)) {
	          // Merge tokens together;
	          result = _.concat(warp,
	            utils.token.newLiteral(options.warpAndWeftSeparator),
	            weft);
	        } else
	        if (_.isObject(warp) && _.isObject(weft)) {
	          // Create AST with different warp and weft; merge meta;
	          // do not use palette
	          result = {
	            meta: _.extend({}, warp.meta, weft.meta),
	            warp: chooseRootBlock([warp.warp, warp.weft]),
	            weft: chooseRootBlock([weft.warp, weft.weft])
	          };
	        }
	      }
	    } else
	    if (_.isString(source.threadcount) || _.isString(source.sett)) {
	      // Try to parse entire threadcount
	      var threadcount = chooseNonEmptyString([source.threadcount, source.sett]);
	      result = parse(parsers, threadcount, options);
	    } else {
	      // Create empty result
	      result = parse(parsers, '', options);
	    }
	
	    if (_.isString(source.palette) || _.isString(source.colors)) {
	      // Try to add palette - as tokens or as color map
	      var palette = chooseNonEmptyString([source.palette, source.colors]);
	      palette = parse(parsers, palette, options);
	      if (_.isArrayLike(result)) {
	        if (_.isArrayLike(palette)) {
	          result = _.concat(palette, result);
	        }
	      } else
	      if (_.isObject(result)) {
	        if (_.isObject(palette)) {
	          result.colors = palette.colors;
	          result.meta = _.extend({}, palette.meta, result.meta);
	        }
	      }
	    }
	
	    if (_.isObject(result)) {
	      result.colors = _.extend({}, result.colors);
	      if (_.isFunction(options.getSourceMeta)) {
	        result.meta = _.extend({}, result.meta, options.getSourceMeta(source));
	      } else {
	        result.meta = _.extend({}, result.meta);
	      }
	    }
	
	    return result;
	  };
	}
	
	module.exports = factory;
	
	module.exports.source = __webpack_require__(18);
	
	module.exports.color = __webpack_require__(20);
	module.exports.stripe = __webpack_require__(21);
	module.exports.pivot = __webpack_require__(22);
	module.exports.repeat = __webpack_require__(23);
	module.exports.literal = __webpack_require__(24);


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var stringSource = __webpack_require__(13);
	var objectSource = __webpack_require__(14);
	
	function factory(source) {
	  if (_.isFunction(source)) {
	    source = source();
	  }
	  if (_.isString(source)) {
	    return stringSource(source);
	  }
	  return objectSource(source);
	}
	
	module.exports = factory;
	// Define some properties for `factory()` function
	Object.defineProperty(module.exports, 'id', {
	  enumerable: true,
	  value: 'autodetect'
	});
	Object.defineProperty(module.exports, 'name', {
	  enumerable: true,
	  value: 'Autodetect'
	});


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	function factory(source) {
	  return {
	    threadcount: _.isString(source) ? source : ''
	  };
	}
	
	module.exports = factory;
	// Define some properties for `factory()` function
	Object.defineProperty(module.exports, 'id', {
	  enumerable: true,
	  value: 'string'
	});
	Object.defineProperty(module.exports, 'name', {
	  enumerable: true,
	  value: 'String'
	});


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	function factory(source) {
	  return _.extend({threadcount: ''}, source);
	}
	
	module.exports = factory;
	// Define some properties for `factory()` function
	Object.defineProperty(module.exports, 'id', {
	  enumerable: true,
	  value: 'object'
	});
	Object.defineProperty(module.exports, 'name', {
	  enumerable: true,
	  value: 'Object'
	});


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var whitespace = __webpack_require__(16);
	var invalid = __webpack_require__(17);
	
	function Context(source, parsers, options) {
	  this.source = _.isString(source) ? source : '';
	
	  parsers = _.filter(parsers, _.isFunction);
	  parsers.splice(0, 0, whitespace()); // Prepend this parser to skip spaces
	  parsers.push(invalid()); // This parser will handle invalid tokens
	  this.parsers = parsers;
	  this.options = options;
	
	  this.inForesee = 0;
	
	  if (_.isFunction(options.errorHandler)) {
	    this.errorHandler = function(error, data, severity) {
	      options.errorHandler(error, data, severity || 'error');
	    };
	  }
	}
	
	Context.prototype = {};
	
	Context.prototype.errorHandler = function(error, data, severity) {
	  // Do nothing - default error handler will just ignore all errors.
	};
	
	function getToken(context, offset) {
	  var result = null;
	
	  _.each(context.parsers, function(parser) {
	    result = parser(context, offset);
	    if (_.isObject(result)) {
	      result.offset = result.offset || offset;
	      return false; // Break
	    }
	  });
	
	  return result;
	}
	
	Context.prototype.foresee = function(offset) {
	  var foreseeLimit = this.options.foreseeLimit;
	  if (this.inForesee >= foreseeLimit) {
	    return null;
	  }
	
	  offset = parseInt(offset, 10) || 0;
	  if (offset < 0) {
	    offset = 0;
	  }
	
	  if (offset <= this.offset) {
	    this.errorHandler(new Error('Parser should not go back.'), {
	      currentOffset: this.offset,
	      requestedOffset: offset,
	      source: this.source
	    });
	    return null;
	  }
	
	  this.inForesee++;
	  var result = getToken(this, offset);
	  if (this.inForesee > 0) {
	    this.inForesee--;
	  }
	  return result;
	};
	
	Context.prototype.parse = function(offset) {
	  var result = [];
	
	  offset = parseInt(offset, 10) || 0;
	  if (offset < 0) {
	    offset = 0;
	  }
	
	  while (offset < this.source.length) {
	    this.offset = offset;
	    var token = getToken(this, offset);
	    if (_.isObject(token)) {
	      result.push(token);
	      offset = token.offset + token.length;
	    }
	  }
	
	  return result;
	};
	
	function factory(source, parsers, options) {
	  options = _.extend({}, options);
	  options.foreseeLimit = parseInt(options.foreseeLimit, 10) || 0;
	  if (options.foreseeLimit < 1) {
	    options.foreseeLimit = 1;
	  }
	  return new Context(source, parsers, options);
	}
	
	module.exports = factory;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var pattern = /^\s+/i;
	var utils = __webpack_require__(4);
	
	function parse(context, offset) {
	  var source = context.source;
	  var chunkSize = 10;
	  var result = '';
	  while (true) {
	    var chunk = source.substr(offset + result.length, chunkSize);
	    var matches = pattern.exec(chunk);
	    if (!matches) {
	      break;
	    }
	    result += matches[0];
	    if (matches[0].length < chunkSize) {
	      // Don't wait for next turn
	      break;
	    }
	  }
	
	  if (result != '') {
	    return {
	      type: utils.token.whitespace,
	      value: result,
	      length: result.length
	    };
	  }
	}
	
	function factory() {
	  return parse;
	}
	
	module.exports = factory;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	function parse(context, offset) {
	  var source = context.source;
	  var result = source.charAt(offset);
	
	  if (!context.inForesee) {
	    var foreseeOffset = offset + 1;
	    while (true) {
	      var token = context.foresee(foreseeOffset);
	      if (_.isObject(token) && (token.type == 'invalid')) {
	        result += token.value;
	        foreseeOffset += token.length;
	        continue;
	      }
	      break;
	    }
	  }
	
	  if (result != '') {
	    result = {
	      type: utils.token.invalid,
	      value: result,
	      length: result.length
	    };
	    if (!context.inForesee) {
	      context.errorHandler(
	        new Error(utils.error.message.invalidToken),
	        {token: result},
	        utils.error.severity.error
	      );
	    }
	    return result;
	  }
	}
	
	function factory() {
	  return parse;
	}
	
	module.exports = factory;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.autodetect = __webpack_require__(12);
	module.exports.string = __webpack_require__(13);
	module.exports.object = __webpack_require__(14);
	module.exports.json = __webpack_require__(19);


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	function factory(source) {
	  return _.extend(
	    {threadcount: ''},
	    _.isString(source) ? JSON.parse(source) : source
	  );
	}
	
	module.exports = factory;
	// Define some properties for `factory()` function
	Object.defineProperty(module.exports, 'id', {
	  enumerable: true,
	  value: 'json'
	});
	Object.defineProperty(module.exports, 'name', {
	  enumerable: true,
	  value: 'JSON'
	});


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	var defaultOptions = {
	  // Name can have more than one character
	  allowLongNames: true,
	  // Regular expression or string; case-insensitive
	  colorPrefix: /[=]?[#]/,
	  // Regular expression or string; case-insensitive
	  colorSuffix: /;?/,
	  // Formats: `short` (#fc0), `long` (#ffcc00) or `both`
	  colorFormat: 'both',
	  allowComment: false,
	  // Regular expression or string; case-insensitive
	  commentSuffix: /;/,
	  requireCommentSuffix: true,
	  // Regular expression; value of first group will be used to modify
	  // comment (if available)
	  commentFormat: /^\s*(.*)\s*;\s*$/
	};
	
	function validateOptions(options) {
	  options.colorFormat = _.trim(('' + options.colorFormat).toLowerCase());
	  if (['long', 'short', 'both'].indexOf(options.colorFormat) == -1) {
	    options.colorFormat = defaultOptions.colorFormat;
	  }
	
	  if (options.colorPrefix instanceof RegExp) {
	    options.colorPrefix = options.colorPrefix.source;
	  } else
	  if (!_.isString(options.colorPrefix)) {
	    options.colorPrefix = '';
	  }
	
	  if (options.colorSuffix instanceof RegExp) {
	    options.colorSuffix = options.colorSuffix.source;
	  } else
	  if (!_.isString(options.colorSuffix)) {
	    options.colorSuffix = '';
	  }
	
	  if (options.commentSuffix instanceof RegExp) {
	    var flags = options.commentSuffix.ignoreCase ? 'i' : '';
	    options.commentSuffix = new RegExp(
	      '^' + options.commentSuffix.source, flags);
	  } else {
	    options.commentSuffix = null;
	  }
	
	  if (!(options.commentFormat instanceof RegExp)) {
	    options.commentFormat = null;
	  }
	
	  return options;
	}
	
	function buildRegExp(options) {
	  var result = ['^'];
	
	  // Name part
	  var part = '[a-z]';
	  if (options.allowLongNames) {
	    part += '{1,100}';
	  }
	  result.push('(' + part + ')');
	
	  // Color format
	  result.push('(' + options.colorPrefix + ')');
	  switch (options.colorFormat) {
	    case 'long':
	      result.push('([0-9a-f]{6})');
	      break;
	    case 'short':
	      result.push('([0-9a-f]{3})');
	      break;
	    case 'both':
	      result.push('([0-9a-f]{6}|[0-9a-f]{3})');
	      break;
	    default:
	      break;
	  }
	  result.push(options.colorSuffix);
	
	  return new RegExp(result.join(''), 'i');
	}
	
	function parser(context, offset, pattern, options) {
	  var source = context.source;
	  var matches;
	  var chunk;
	  var i;
	
	  chunk = source.substr(offset, 200);
	
	  matches = pattern.exec(chunk);
	  if (matches) {
	    var result = {
	      type: utils.token.color,
	      name: matches[1].toUpperCase(),
	      // matches[2] is color prefix
	      color: utils.color.normalizeColor(matches[3]),
	      comment: '',
	      length: matches[0].length
	    };
	
	    if (!context.inForesee) {
	      if (options.allowComment) {
	        var commentOffset = offset + result.length;
	        if (options.commentSuffix && options.requireCommentSuffix) {
	          // Fast case - just search for suffix
	          for (i = commentOffset; i < source.length; i++) {
	            chunk = source.substr(i, 10);
	            matches = options.commentSuffix.exec(chunk);
	            if (matches) {
	              result.comment = source.substr(commentOffset,
	                i - commentOffset + matches[0].length);
	              break;
	            }
	          }
	          if (i >= source.length) {
	            result.comment = source.substr(commentOffset, source.length);
	          }
	        } else {
	          var ignoreTokens = ['whitespace', 'invalid'];
	          // Slow - search for next token or suffix (if available)
	          for (i = commentOffset; i < source.length; i++) {
	            chunk = source.substr(i, 10);
	            matches = options.commentSuffix.exec(chunk);
	            if (matches) {
	              result.comment = source.substr(commentOffset,
	                i - commentOffset + matches[0].length);
	              break;
	            }
	            var token = context.foresee(i);
	            if (_.isObject(token) && (ignoreTokens.indexOf(token.type) == -1)) {
	              result.comment = source.substr(commentOffset,
	                i - commentOffset);
	              break;
	            }
	          }
	          if (i >= source.length) {
	            result.comment = source.substr(commentOffset, source.length);
	          }
	        }
	      }
	
	      result.length += result.comment.length;
	
	      if (options.commentFormat) {
	        matches = options.commentFormat.exec(result.comment);
	        if (matches && _.isString(matches[1])) {
	          result.comment = matches[1];
	        }
	      }
	      result.comment = _.trim(result.comment);
	    }
	
	    return result;
	  }
	}
	
	function factory(options) {
	  options = validateOptions(_.extend({}, defaultOptions, options));
	  var pattern = buildRegExp(options);
	  return function(context, offset) {
	    return parser(context, offset, pattern, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	var defaultOptions = {
	  // Name can have more than one character
	  allowLongNames: true
	};
	
	function buildRegExp(options) {
	  var result = ['^'];
	
	  // Name part
	  var part = '[a-z]';
	  if (options.allowLongNames) {
	    part += '{1,100}';
	  }
	  result.push('(' + part + ')');
	
	  // Count part
	  result.push('([0-9]+)');
	
	  return new RegExp(result.join(''), 'i');
	}
	
	function parser(context, offset, pattern, options) {
	  var source = context.source;
	
	  // Hope nobody will try to add stripe with 1e19 lines...
	  var matches = pattern.exec(source.substr(offset, 20));
	  if (matches) {
	    var count = parseInt(matches[2], 10) || 0;
	    if (count < 0) {
	      count = 0;
	    }
	    var result = {
	      type: utils.token.stripe,
	      name: matches[1].toUpperCase(),
	      count: count,
	      length: matches[0].length
	    };
	
	    if (result.count == 0) {
	      context.errorHandler(
	        new Error(utils.error.message.zeroWidthStripe),
	        {token: result},
	        utils.error.severity.warning
	      );
	    }
	
	    return result;
	  }
	}
	
	function factory(options) {
	  options = _.extend({}, defaultOptions, options);
	  var pattern = buildRegExp(options);
	  return function(str, offset) {
	    return parser(str, offset, pattern, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	var defaultOptions = {
	  // Name can have more than one character
	  allowLongNames: true
	};
	
	function buildRegExp(options) {
	  var result = ['^'];
	
	  // Name part
	  var part = '[a-z]';
	  if (options.allowLongNames) {
	    part += '{1,100}';
	  }
	  result.push('(' + part + ')');
	
	  // Count part
	  result.push('/([0-9]+)');
	
	  return new RegExp(result.join(''), 'i');
	}
	
	function parser(context, offset, pattern, options) {
	  var source = context.source;
	
	  // Hope nobody will try to add stripe with 1e19 lines...
	  var matches = pattern.exec(source.substr(offset, 20));
	  if (matches) {
	    var count = parseInt(matches[2], 10) || 0;
	    if (count < 0) {
	      count = 0;
	    }
	    var result = {
	      type: utils.token.pivot,
	      name: matches[1].toUpperCase(),
	      count: count,
	      length: matches[0].length
	    };
	
	    if (result.count == 0) {
	      context.errorHandler(
	        new Error(utils.error.message.zeroWidthStripe),
	        {token: result},
	        utils.error.severity.warning
	      );
	    }
	
	    return result;
	  }
	}
	
	function factory(options) {
	  options = _.extend({}, defaultOptions, options);
	  var pattern = buildRegExp(options);
	  return function(str, offset) {
	    return parser(str, offset, pattern, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	var defaultOptions = {
	  // NNN * <something> variant
	  allowAsPrefix: true,
	  // <something> * NNN variant
	  allowAsSuffix: true
	};
	
	var patternPrefix = /^([0-9]+)\s*[*]/i;
	var patternSuffix = /^[*]\s*([0-9]+)/i;
	
	function parser(context, offset, options) {
	  var source = context.source;
	
	  var matches = null;
	  var isPrefix = false;
	  var isSuffix = false;
	
	  if (options.allowAsPrefix) {
	    matches = patternPrefix.exec(source.substr(offset, 20));
	    isPrefix = !!matches;
	  }
	
	  if (options.allowAsSuffix && !matches) {
	    matches = patternSuffix.exec(source.substr(offset, 20));
	    isSuffix = !!matches;
	  }
	
	  if (matches) {
	    var count = parseInt(matches[1], 10) || 0;
	    if (count <= 0) {
	      count = 1;
	    }
	    var result = {
	      type: utils.token.repeat,
	      count: count >= 1 ? count : 1,
	      isPrefix: isPrefix,
	      isSuffix: isSuffix,
	      length: matches[0].length
	    };
	
	    if (count < 1) {
	      context.errorHandler(
	        new Error(utils.error.message.invalidMultiplier),
	        {token: _.extend({}, result, {count: count})},
	        utils.error.severity.warning
	      );
	    }
	
	    return result;
	  }
	}
	
	function factory(options) {
	  options = _.extend({}, defaultOptions, options);
	  return function(str, offset) {
	    return parser(str, offset, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	var defaultOptions = {
	  string: '',
	  ignoreCase: false
	};
	
	function parser(context, offset, options) {
	  var source = context.source;
	  if (options.string != '') {
	    var s = source.substr(offset, options.string.length);
	    var q = options.ignoreCase ? s.toUpperCase() : s;
	    if (q == options.string) {
	      return {
	        type: utils.token.literal,
	        value: s,
	        length: s.length
	      };
	    }
	  }
	}
	
	function factory(options) {
	  if (_.isString(options)) {
	    options = {string: options};
	  }
	  options = _.extend({}, defaultOptions, options);
	  if (!_.isString(options.string)) {
	    options.string = '';
	  }
	  if (options.ignoreCase) {
	    options.string = options.string.toUpperCase();
	  }
	  return function(str, offset) {
	    return parser(str, offset, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	function factory(processors) {
	  processors = _.filter(processors, _.isFunction);
	
	  return function(tokens) {
	    if (_.isArray(tokens)) {
	      for (var i = 0; i < processors.length; i++) {
	        tokens = processors[i](tokens);
	      }
	    }
	    return tokens;
	  };
	}
	
	module.exports = factory;
	
	module.exports.classify = __webpack_require__(26);
	module.exports.removeTokens = __webpack_require__(27);


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	var defaults = __webpack_require__(3);
	
	var defaultOptions = {
	  isColor: function(token, index, tokens) {
	    return utils.token.isColor(token);
	  },
	  isStripe: function(token, index, tokens) {
	    return utils.token.isStripe(token);
	  },
	  isPivot: function(token, index, tokens) {
	    return utils.token.isPivot(token);
	  },
	  isRepeat: function(token, index, tokens) {
	    return utils.token.isRepeat(token);
	  },
	  isWarpAndWeftSeparator: function(token, index, tokens) {
	    return utils.token.isLiteral(token) &&
	      (token.value == defaults.warpAndWeftSeparator);
	  },
	  isBlockStart: function(token, index, tokens) {
	    return utils.token.isOpeningSquareBracket(token) ||
	      utils.token.isOpeningParenthesis(token);
	  },
	  isBlockEnd: function(token, index, tokens) {
	    return utils.token.isClosingSquareBracket(token) ||
	      utils.token.isClosingParenthesis(token);
	  }
	};
	
	function isNone(token, index, tokens) {
	  return false;
	}
	
	function process(tokens, options) {
	  return _.map(tokens, function(token, index) {
	    var result = _.clone(token);
	    _.each(options, function(check, property) {
	      result[property] = check(token, index, tokens);
	    });
	    return result;
	  });
	}
	
	function factory(options) {
	  options = _.extend({}, defaultOptions, options);
	  _.each(defaultOptions, function(value, key) {
	    if (!_.isFunction(options[key])) {
	      options[key] = isNone;
	    }
	  });
	  return function(tokens) {
	    return process(tokens, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var defaults = __webpack_require__(3);
	
	function createPredicate(typesOrPredicate) {
	  // Predicate should return `true` if token should be removed from list
	  if (_.isFunction(typesOrPredicate)) {
	    return typesOrPredicate;
	  }
	  if (!_.isArray(typesOrPredicate)) {
	    typesOrPredicate = defaults.insignificantTokens;
	  }
	  return function(token) {
	    return _.isObject(token) ? typesOrPredicate.indexOf(token.type) >= 0 : true;
	  };
	}
	
	function factory(typesOrPredicate) {
	  var predicate = createPredicate(typesOrPredicate);
	  return function(tokens) {
	    return _.filter(tokens, function(token) {
	      return !predicate(token);
	    });
	  };
	}
	
	module.exports = factory;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	function factory(processors) {
	  processors = _.filter(processors, _.isFunction);
	
	  return function(sett) {
	    if (_.isObject(sett)) {
	      _.each(processors, function(processor) {
	        sett = processor(sett);
	      });
	    }
	    return sett;
	  };
	}
	
	module.exports = factory;
	
	module.exports.flatten = __webpack_require__(29);
	module.exports.fold = __webpack_require__(30);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	function flatten(block) {
	  var result = [];
	
	  // Flatten nested blocks
	  _.each(block.items, function(item) {
	    if (item.isBlock) {
	      // Flatten nested block
	      item = flatten(item);
	      [].push.apply(result, item.items);
	    } else {
	      result.push(item);
	    }
	  });
	
	  // Reflect and repeat
	  block = _.clone(block);
	  block.items = result;
	  return utils.sett.reflectAndRepeat(block);
	}
	
	function transform(sett) {
	  var result = _.clone(sett);
	  var warpIsSameAsWeft = sett.warp == sett.weft;
	
	  if (_.isObject(sett.warp)) {
	    result.warp = flatten(sett.warp);
	  }
	  if (_.isObject(sett.weft)) {
	    if (warpIsSameAsWeft) {
	      result.weft = result.warp;
	    } else {
	      result.weft = flatten(sett.weft);
	    }
	  }
	
	  return result;
	}
	
	function factory() {
	  return transform;
	}
	
	module.exports = factory;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	var defaultOptions = {
	  calculateNodeWeight: utils.node.calculateNodeWeight
	};
	
	function tryFoldBlock(items) {
	  // Smallest reflective sett contains 3 stripes in threadcount or
	  // 5 stripes when unfolded, i.e. R/10 K2 Y/2 => R10 K2 Y2 K2 R10;
	  // R/10 K/2 => R10 K2
	  if ((items.length < 5) || (items.length % 2 != 1)) {
	    return;
	  }
	
	  var left;
	  var right;
	
	  var result = [];
	  var i = 0;
	  var j = items.length - 1;
	  while (true) {
	    left = items[i];
	    right = items[j];
	    if (utils.node.isSameNode(left, right)) {
	      result.push(left);
	      if (i == j) {
	        break;
	      }
	      i++;
	      j--;
	      continue;
	    }
	    return;
	  }
	
	  return result;
	}
	
	function foldRootBlock(root, options, results) {
	  if (root.reflect || (root.items.length == 0)) {
	    return;
	  }
	
	  var items = _.concat(root.items, root.items[0]);
	  var resultItems = tryFoldBlock(items);
	  if (_.isArray(resultItems)) {
	    var result = _.clone(root);
	    result.items = resultItems;
	    result.reflect = true;
	    results.push({
	      node: result,
	      hash: utils.node.calculateNodeHash(result),
	      weight: options.calculateNodeWeight(result)
	    });
	  }
	}
	
	function processTokens(root, options, doNotLog) {
	  var variants = [];
	  foldRootBlock(root, options, variants);
	  variants.push({
	    node: root,
	    hash: utils.node.calculateNodeHash(root),
	    weight: options.calculateNodeWeight(root)
	  });
	
	  // There may be at most two variants: unfolded and folded;
	  // folded is better.
	  return variants;
	}
	
	function transform(sett, options) {
	  var result = _.clone(sett);
	
	  var warpIsSameAsWeft = sett.warp === sett.weft;
	  if (_.isObject(sett.warp)) {
	    result.warpVariants = processTokens(sett.warp, options, true);
	  }
	  if (_.isObject(sett.weft)) {
	    if (warpIsSameAsWeft) {
	      result.weftVariants = result.warpVariants;
	    } else {
	      result.weftVariants = processTokens(sett.weft, options, true);
	    }
	  }
	
	  // Take the best variant, but keep other too
	  result.warp = _.first(result.warpVariants).node;
	  result.weft = _.first(result.weftVariants).node;
	
	  return result;
	}
	
	function factory(options) {
	  options = _.extend({}, defaultOptions, options);
	  return function(sett) {
	    return transform(sett, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.classic = __webpack_require__(32);


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var utils = __webpack_require__(4);
	
	var defaultOptions = {
	  // Error handler
	  errorHandler: function(error, data, severity) {
	    // Do nothing
	  },
	  // function to filter parsed tokens: (tokens) => { return modifiedTokens; }
	  processTokens: null,
	  // function to transform newly built AST: (ast) => { return modifiedAst; }
	  transformSyntaxTree: null
	};
	
	/*
	 <sett> ::= <sequence> [ '//' <sequence> ]
	 <sequence> ::= <reflected> | <repetitive>
	 <reflected> ::= <pivot> [{ <color> | <stripe> }] <pivot>
	 <repetitive> ::= { <color> | <stripe> }
	*/
	
	function buildTree(tokens, options) {
	  var items = [];
	  var isReflected = false;
	  var first = null;
	  var last = null;
	
	  if (tokens.length >= 2) {
	    first = _.first(tokens);
	    last = _.last(tokens);
	    if (first.isPivot && last.isPivot) {
	      isReflected = true;
	    }
	  }
	
	  _.each(tokens, function(token) {
	    if (token.isStripe) {
	      items.push(utils.node.newStripe(token));
	      return;
	    }
	    if (token.isPivot) {
	      if (isReflected) {
	        if ((token === first) || (token === last)) {
	          items.push(utils.node.newStripe(token));
	          return;
	        }
	      }
	      options.errorHandler(
	        new Error(utils.error.message.orphanedPivot),
	        {token: token},
	        utils.error.severity.warning
	      );
	      items.push(utils.node.newStripe(token));
	      return;
	    }
	    options.errorHandler(
	      new Error(utils.error.message.unexpectedToken),
	      {token: token},
	      utils.error.severity.error
	    );
	  });
	
	  return utils.node.newRootBlock(items, isReflected);
	}
	
	function buildSyntaxTree(tokens, options) {
	  // Some pre-validation and filtering
	  if (!_.isArray(tokens)) {
	    return tokens;
	  }
	  if (_.isFunction(options.processTokens)) {
	    tokens = options.processTokens(tokens);
	    if (!_.isArray(tokens)) {
	      return tokens;
	    }
	  }
	
	  // Extract colors; split warp and weft
	  var colorTokens = [];
	  var warpTokens = [];
	  var weftTokens = [];
	  var current = warpTokens;
	  _.each(tokens, function(token) {
	    if (token.isColor) {
	      colorTokens.push(token);
	      return;
	    }
	    if (token.isWarpAndWeftSeparator) {
	      if (current === weftTokens) {
	        options.errorHandler(
	          new Error(utils.error.message.multipleWarpAnWeftSeparator),
	          {token: token},
	          utils.error.severity.warning
	        );
	      }
	      current = weftTokens;
	    } else {
	      current.push(token);
	    }
	  });
	  if (warpTokens.length == 0) {
	    warpTokens = weftTokens;
	    weftTokens = [];
	  }
	  if (weftTokens.length == 0) {
	    weftTokens = warpTokens;
	  }
	
	  var result = {};
	  result.colors = utils.color.buildColorMap(colorTokens);
	  result.warp = buildTree(warpTokens, options);
	  if (weftTokens === warpTokens) {
	    result.weft = result.warp;
	  } else {
	    result.weft = buildTree(weftTokens, options);
	  }
	
	  if (_.isFunction(options.transformSyntaxTree)) {
	    result = options.transformSyntaxTree(result);
	  }
	
	  return result;
	}
	
	function factory(options) {
	  options = _.extend({}, defaultOptions, options);
	  if (!_.isFunction(options.errorHandler)) {
	    options.errorHandler = defaultOptions.errorHandler;
	  }
	  return function(tokens) {
	    return buildSyntaxTree(tokens, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.format = __webpack_require__(34);


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	var defaultOptions = {
	  // function to transform newly built AST: (sett) => { return modifiedSett; }
	  transformSyntaxTree: null,
	  format: {
	    color: function(item) {
	      var comment = item.comment != '' ? ' ' + item.comment : '';
	      return item.name + item.value + comment + ';';
	    },
	    stripe: function(item) {
	      return item.name + item.count;
	    },
	    block: function(block) {
	      var result = _.chain(block.formattedItems).join(' ').trim().value();
	      if (result == '') {
	        return '';
	      }
	      var multiply = block.repeat > 1 ? '*' + block.repeat : '';
	      if (block.isRoot) {
	        result = block.reflect ? '[' + result + ']' : result;
	      } else {
	        result = block.reflect ? '[' + result + ']' : '(' + result + ')';
	      }
	      return result + multiply;
	    }
	  },
	  join: function(components) {
	    var parts = [];
	    if (components.colors.length > 0) {
	      parts.push(components.colors.join(' '));
	    }
	    if (components.warp != components.weft) {
	      parts.push(components.warp + ' // ' + components.weft);
	    } else {
	      parts.push(components.warp);
	    }
	    return parts.join('\n');
	  },
	  defaultColors: {},
	  includeUnusedColors: true,
	  includeDefaultColors: true
	};
	
	function processColors(usedColors, settColors, options) {
	  var defaultColors = _.extend({}, options.defaultColors);
	  var keys = _.intersection(_.keys(settColors), _.keys(usedColors));
	  if (options.includeUnusedColors) {
	    keys = _.keys(settColors);
	  }
	  if (options.includeDefaultColors) {
	    keys = _.union(_.keys(settColors), _.keys(usedColors));
	  }
	
	  var format = options.format;
	  if (!_.isFunction(format.color)) {
	    return [];
	  }
	
	  return _.chain(keys)
	    .sortBy()
	    .map(function(key) {
	      var color = settColors[key] || defaultColors[key];
	      if (color) {
	        return format.color(_.extend({name: key}, color));
	      }
	      return null;
	    })
	    .filter(function(str) {
	      return _.isString(str) && (str.length > 0);
	    })
	    .value();
	}
	
	function process(block, options, usedColors) {
	  var format = options.format;
	  if (!_.isFunction(format.stripe) || !_.isFunction(format.block)) {
	    return '';
	  }
	
	  block = _.clone(block);
	  block.formattedItems = _.chain(block.items)
	    .map(function(item) {
	      if (item.isStripe) {
	        usedColors[item.name] = true;
	        return format.stripe(item);
	      }
	      if (item.isBlock) {
	        return process(item, options, usedColors);
	      }
	      return '';
	    })
	    .filter(function(str) {
	      return str.length > 0;
	    })
	    .value();
	  return _.isFunction(format.block) ? format.block(block) : '';
	}
	
	function render(sett, options) {
	  var warpIsSameAsWeft = sett.warp === sett.weft;
	
	  var usedColors = {};
	  var warp = process(sett.warp, options, usedColors);
	  var weft = warp;
	  if (!warpIsSameAsWeft) {
	    weft = process(sett.weft, options, usedColors);
	  }
	
	  var colors = processColors(usedColors, sett.colors, options);
	
	  return _.trim(options.join({
	    colors: colors,
	    warp: warp,
	    weft: weft
	  }, sett));
	}
	
	function factory(options) {
	  options = _.merge({}, defaultOptions, options);
	
	  return function(sett) {
	    if (!_.isObject(sett)) {
	      return '';
	    }
	    if (_.isFunction(options.transformSyntaxTree)) {
	      sett = options.transformSyntaxTree(sett);
	    }
	
	    return render(sett, options);
	  };
	}
	
	module.exports = factory;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.classic = __webpack_require__(36);


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(3);
	
	module.exports.id = 'classic';
	module.exports.name = 'Classic (strict syntax)';
	module.exports.parse = __webpack_require__(37);
	module.exports.format = __webpack_require__(38);
	module.exports.colors = defaults.colors;
	module.exports.warpAndWeftSeparator = defaults.warpAndWeftSeparator;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var index = __webpack_require__(36);
	var defaults = __webpack_require__(3);
	var parse = __webpack_require__(11);
	var filter = __webpack_require__(25);
	var syntax = __webpack_require__(31);
	var utils = __webpack_require__(4);
	
	/*
	  options = {
	    warpAndWeftSeparator: index.warpAndWeftSeparator,
	    errorHandler: <default>,
	    processTokens: <default>,
	    transformSyntaxTree: <default>
	  }
	*/
	
	function factory(options) {
	  options = _.extend({}, options);
	
	  if (!_.isString(options.warpAndWeftSeparator)) {
	    options.warpAndWeftSeparator = '';
	  }
	  if (options.warpAndWeftSeparator == '') {
	    options.warpAndWeftSeparator = index.warpAndWeftSeparator;
	  }
	
	  return parse([
	    parse.pivot(),
	    parse.stripe(),
	    parse.literal(options.warpAndWeftSeparator),
	    parse.color({
	      allowLongNames: true,
	      colorPrefix: /[=]?[#]/,
	      colorSuffix: null,
	      colorFormat: 'long',
	      allowComment: true,
	      commentSuffix: /;/,
	      requireCommentSuffix: true,
	      commentFormat: /^\s*(.*)\s*;\s*$/
	    })
	  ], {
	    errorHandler: options.errorHandler,
	    processTokens: filter([
	      options.processTokens,
	      filter.removeTokens(defaults.insignificantTokens)
	    ]),
	    buildSyntaxTree: syntax.classic({
	      errorHandler: options.errorHandler,
	      processTokens: filter.classify({
	        isWarpAndWeftSeparator: function(token) {
	          return utils.token.isLiteral(token) &&
	            (token.value == options.warpAndWeftSeparator);
	        }
	      }),
	      transformSyntaxTree: options.transformSyntaxTree
	    })
	  });
	}
	
	module.exports = factory;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var index = __webpack_require__(36);
	var render = __webpack_require__(33);
	var transform = __webpack_require__(28);
	
	function formatPivot(str) {
	  return str.replace(/^([a-z]+)([0-9]+)$/i, '$1/$2');
	}
	
	var defaultOptions = {
	  format: {
	    color: function(item) {
	      var comment = item.comment != '' ? ' ' + item.comment : '';
	      return item.name + item.value + comment + ';';
	    },
	    stripe: function(item) {
	      return item.name + item.count;
	    },
	    block: function(block) {
	      var items = block.formattedItems;
	      if (block.reflect && (items.length >= 2)) {
	        // Convert first and last to pivots
	        items[0] = formatPivot(items[0]);
	        items[items.length - 1] = formatPivot(items[items.length - 1]);
	      }
	      return _.chain(items).join(' ').trim().value();
	    }
	  }
	};
	
	// Options same as for tartan.render.format():
	// + warpAndWeftSeparator: index.warpAndWeftSeparator
	// - format
	// - join
	function factory(options) {
	  options = _.extend({}, options, defaultOptions);
	
	  if (!_.isString(options.warpAndWeftSeparator)) {
	    options.warpAndWeftSeparator = '';
	  }
	  if (options.warpAndWeftSeparator == '') {
	    options.warpAndWeftSeparator = index.warpAndWeftSeparator;
	  }
	
	  options.transformSyntaxTree = transform([
	    options.transformSyntaxTree,
	    transform.flatten(),
	    transform.fold({
	      allowRootReorder: false,
	      allowNestedBlocks: false,
	      maxFoldLevels: 2,
	      minBlockSize: 3,
	      greedy: false,
	      allowSplitStripe: false,
	      processExistingBlocks: false
	    })
	  ]);
	
	  options.join = function(components) {
	    var parts = [];
	    if (components.colors.length > 0) {
	      parts.push(components.colors.join(' '));
	    }
	    if (components.warp != components.weft) {
	      parts.push(components.warp + ' ' + options.warpAndWeftSeparator +
	        ' ' + components.weft);
	    } else {
	      parts.push(components.warp);
	    }
	    return parts.join('\n');
	  };
	
	  return render.format(options);
	}
	
	module.exports = factory;


/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// tartan.min.js